import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Typography, Button, Container, Paper } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const AuthError = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  const errorMessage = location.state?.error || 'Authentication failed. Please try again.';

  const getDashboardRoute = (role) => {
    const roleRoutes = {
      admin: "/superadmin",
      cs: "/csdashboard",
      ca: "/Cadashboard",
      lawyer: "/Legal",
      user: "/KycManagement",
    };

    return roleRoutes[role?.toLowerCase()] || "/Dashboard";
  };

  const handleGoBack = () => {
    if (isAuthenticated && user?.role) {
      navigate(getDashboardRoute(user.role));
    } else {
      navigate('/login');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper 
        elevation={3}
        sx={{
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          borderRadius: 2
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 60, color: 'error.main', mb: 3 }} />
        <Typography variant="h5" gutterBottom>
          Authentication Error
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {errorMessage}
        </Typography>
        <Button 
          variant="contained" 
          onClick={handleGoBack}
          sx={{
            mt: 2,
            color: "black",
            backgroundColor: "#EB5A3C",
            '&:hover': {
              backgroundColor: '#ca4e34',
            }
          }}
        >
          {isAuthenticated ? 'Go to Dashboard' : 'Return to Login'}
        </Button>
      </Paper>
    </Container>
  );
};

export default AuthError;